
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin } from '@/mixins';

@Component
export default class SharingMetric extends Mixins(VuetifyMixin){
	@Prop() value: Number;
	@Prop() label: String;
}
